import { createContext } from 'react';

import { IAuthContextType } from '@/types/auth';

const AuthContext = createContext<IAuthContextType | null>(null);

export default AuthContext;
